<template>
  <div style="background-color:#fff;padding: 10px">
    <div style="padding-bottom: 10px">
      <a-row>
        <a-col :xs="24" :md="5">
          <span class="search-form-label">用户名：</span>
          <a-input v-model="searchParam.username" style="width: 70%;" @keyup.enter="searchList(pagination.current, pagination.pageSize, searchParam)" />
        </a-col>
        <a-col :xs="24" :md="5">
          <span class="search-form-label">姓名：</span>
          <a-input v-model="searchParam.name" style="width: 70%;" @keyup.enter="searchList(pagination.current, pagination.pageSize, searchParam)" />
        </a-col>
        <a-col :xs="24" :md="5">
          <span class="search-form-label">公司：</span>
          <a-input v-model="searchParam.companyName" style="width: 70%;" @keyup.enter="searchList(pagination.current, pagination.pageSize, searchParam)"/>
        </a-col>
        <a-col :xs="24" :md="5">
          <a-space>
            <a-button type="primary" @click="searchList(pagination.current, pagination.pageSize, searchParam)">查询</a-button>
            <a-button @click="reset">重置</a-button>
            <a-button @click="showSetRoleModal">设置角色</a-button>
          </a-space>
        </a-col>
      </a-row>
    </div>
    <a-table
      :columns="userColumns"
      :data-source="userList"
      :pagination="pagination"
      :rowKey="(record, index)=> record.id"
      :loading="loading"
      :row-selection="rowSelection"
      :custom-row="customRowSelection"
      @change="tableChange"
    />
    <a-modal
      width="520px"
      title="设置角色"
      v-model="setRoleModal.visible"
      ok-text="提交"
      @ok="updateUserRole">
      <a-descriptions>
        <a-descriptions-item label="用户名" :span="3">
          {{ setRoleModal.currentUser.username }}
        </a-descriptions-item>
        <a-descriptions-item label="姓名" :span="1">
          {{ setRoleModal.currentUser.name }}
        </a-descriptions-item>
        <a-descriptions-item label="公司" :span="2">
          {{ setRoleModal.currentUser.companyName }}
        </a-descriptions-item>
        <a-descriptions-item label="地址">
          {{ setRoleModal.currentUser.address }}
        </a-descriptions-item>
      </a-descriptions>
      <a-divider />
      <h4 style="margin-top: 10px">当前角色：</h4>
      <a-select
        mode="multiple"
        style="width: 100%"
        v-model="setRoleModal.roles"
      >
        <a-select-option v-for="role in roleList" :key="role.id" :value="role.id">
          {{ role.name }}
        </a-select-option>
      </a-select>
    </a-modal>
  </div>
</template>

<script>
import userApi from '@/api/user'
import { userColumns } from './data'

export default {
  name: 'index',
  created () {
    this.getList()
    userApi.getRoleList().then(({ data }) => {
      this.roleList = data
    })
  },
  data () {
    return {
      userColumns,
      userList: [],
      pagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['25', '50', '75', '100'],
        showSizeChanger: true,
        total: 50
      },
      searchParam: {
        name: '',
        username: '',
        companyName: ''
      },
      loading: false,
      rowSelection: {
        selectedRowKeys: [],
        onSelect: this.selectRow
      },
      setRoleModal: {
        visible: false,
        currentUser: {},
        roles: []
      },
      roleList: []
    }
  },
  watch: {
    searchParam: {
      handler (newVal, oldVal) {
        this.pagination.current = 1
      },
      deep: true
    }
  },
  methods: {
    getList (current = 1, size = 50) {
      this.loading = true
      userApi.getUserList(current, size).then(({ data: { current, records, size, total } }) => {
        this.userList = records
        this.pagination.current = current
        this.pagination.pageSize = size
        this.pagination.total = total
      }).catch(({ message }) => {
        this.$message.warning(message)
      }).finally(() => {
        this.loading = false
      })
    },
    searchList (current = 1, size = 50, param) {
      this.loading = true
      userApi.searchUserList(current, size, param).then(({ data: { current, records, size, total } }) => {
        this.userList = records
        this.pagination.current = current
        this.pagination.pageSize = size
        this.pagination.total = total
      }).catch(({ message }) => {
        this.$message.warning(message)
      }).finally(() => {
        this.loading = false
      })
    },
    getUserRoleList (userId) {
      return userApi.getUserRoles(userId).then(({ data }) => {
        this.setRoleModal.roles = []
        data.forEach(role => {
          this.setRoleModal.roles.push(role.id)
        })
      })
    },
    tableChange (pagination) {
      if (this.searchParam.username.length > 0 || this.searchParam.name.length > 0 || this.searchParam.companyName.length > 0) {
        this.searchList(pagination.current, pagination.pageSize, this.searchParam)
      } else {
        this.getList(pagination.current, pagination.pageSize)
      }
    },
    reset () {
      this.searchParam = {
        name: '',
        username: '',
        companyName: ''
      }
      this.pagination = {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['25', '50', '75', '100'],
        showSizeChanger: true,
        total: 50
      }
      this.getList()
    },
    selectRow (record) {
      if (this.rowSelection.selectedRowKeys[0] === record.id) {
        this.rowSelection.selectedRowKeys = []
      } else {
        this.rowSelection.selectedRowKeys = [record.id]
        this.setRoleModal.currentUser = record
      }
    },
    customRowSelection (record) {
      return {
        on: {
          click: () => this.selectRow(record)
        }
      }
    },
    showSetRoleModal () {
      if (this.rowSelection.selectedRowKeys.length === 0) {
        this.$message.warning('请先选择用户', 1.5)
      } else {
        this.getUserRoleList(this.rowSelection.selectedRowKeys[0]).then(() => {
          this.setRoleModal.visible = true
        })
      }
    },
    updateUserRole () {
      const userId = this.setRoleModal.currentUser.id
      const roles = this.setRoleModal.roles
      userApi.updateUserRole(userId, roles).then(() => {
        this.$message.success('修改成功', 1)
      }).catch(({ message }) => {
        this.$message.warning(message)
      }).finally(() => {
        this.setRoleModal.visible = false
      })
    }
  }
}
</script>

<style lang="less" scoped>
.search-form-label {
  width: 30%;
}
.ant-divider-horizontal {
  margin: 0;
}
</style>
